import { GetAgeRangeResponse } from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";


export const fetchAgeRange = async () => {
    const url = 'api/v1/age/range';

    try {
        const response: AxiosResponse<GetAgeRangeResponse> = await APICallInstance.get(url);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}